var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tui-loading",style:({
    width: _vm.width,
    height: _vm.height,
    border: ("2px solid " + _vm.color),
    borderTopColor: 'transparent',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }